import { ColumnsSlice } from '../../prismicio-types'
import styles from './Columns.module.css'
import { asHTML } from '@prismicio/client'

export class Columns {
	static render(props: ColumnsSlice) {
		const { items } = props

		return /* HTML */ `
			<div class="${styles.Main}">
				${items
					.map(({ title, text, image }) => {
						return /* HTML */ ` <div class="${styles.Column}">
							<h5 class="${styles.Title}">${title}</h5>
							<div class="${styles.Content}">
								<div class="${styles.Text}">${asHTML(text)}</div>
								${image?.url
									? `<div class="${styles.Image}"><img src="${image.url}" alt="${image.alt}"/></div>`
									: ''}
							</div>
						</div>`
					})
					.join('')}
			</div>
		`
	}
}
